import { render } from "./qyPublicWelfareRecord.vue?vue&type=template&id=1b8321ae&scoped=true"
import script from "./qyPublicWelfareRecord.vue?vue&type=script&lang=js"
export * from "./qyPublicWelfareRecord.vue?vue&type=script&lang=js"

import "./qyPublicWelfareRecord.vue?vue&type=style&index=0&id=1b8321ae&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8321ae"]])

export default __exports__